(function () {
  document.documentElement.classList.add("hfb-073");
  var NAMES = {
    "body-splash-skin-smoothing-body-oil-yummy": "Yummy Body Splash Oil",
    "body-magic-remove-full-body-odor-naturally": "Body Magic Chlorophyll Pill",
    "refresh-ph-balancing-yoni-gel": "Refresh pH Balancing Wash",
    "sweet-skin-body-oil-bundle": "Sweet Skin Oil Bundle",
    "body-splash-skin-smoothing-body-oil-vanilla-drip": "Vanilla Drip Body Splash Oil",
    "fresh-clean-ph-restore-capsules": "Fresh & Clean Boric Suppositories",
    "healthy-box-probiotics": "Healthy Box Probiotics",
    "body-splash-hydrating-body-oil-pineapple-creme": "Pineapple Crème Body Splash Oil",
    "the-everything-bundle": "The Everything Bundle",
    "slippery-box-moisture-capsules": "Slippery Box Moisture Capsules",
    "yummy-body-gel-wash": "Yummy Organic Body Wash",
    "renew-her-booty-kitty-oil": "Renew Her Yoni Oil",
    "fruity-skin-body-oil-bundle": "Fruity Skin Oil Bundle",
    "body-splash-skin-smoothing-body-oil-caramel-glaze": "Caramel Glaze Body Splash Oil",
    "sensitive-probiotic-ph-balanced-wash": "Sensitive Probiotic+ Wash",
    "everywhere-wipes": "Everywhere Odor Wipes"
  };
  var activeItem = null;
  var picked = "";

  function handleFromHref(href) {
    var match = (href || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function pretty(name) {
    var text = (name || "").replace(/\s+/g, " ").trim();
    var month = text.match(/(\d+)\s*months?/i);
    if (month) return "Every " + month[1] + " month";
    return text;
  }

  function delivered(name) {
    var month = (name || "").match(/(\d+)\s*months?/i);
    if (!month || month[1] === "1") return "Delivered every month";
    return "Delivered every " + month[1] + " months";
  }

  function syncItem(item) {
    var link = item.querySelector(".rc90-item-main-header-titles-title-anchor");
    if (link) {
      var shortName = NAMES[handleFromHref(link.getAttribute("href"))];
      if (shortName && link.textContent.trim() !== shortName) link.textContent = shortName;
    }
    var box = item.querySelector(".upsell__checkbox");
    var freq = item.querySelector(".hfb-073-freq");
    var select = item.querySelector(".upsell__options");
    var subLabel = item.querySelector(".upsell__checkbox + label");
    if (subLabel && subLabel.getAttribute("data-hfb-073-label") !== "1") {
      subLabel.innerHTML = "Subscribe &amp; <span>save up to 50%</span>";
      subLabel.setAttribute("data-hfb-073-label", "1");
    }
    if (!freq) return;
    if (!box || !box.checked || !select) {
      freq.hidden = true;
      return;
    }
    var selected = select.options[select.selectedIndex];
    var label = freq.querySelector(".hfb-073-freq__label");
    if (label && selected) {
      var next = delivered(selected.textContent);
      if (label.textContent !== next) label.textContent = next;
    }
    freq.hidden = false;
  }

  function syncSave() {
    var el = document.querySelector(".hfb-073-save");
    if (!el) return;
    var src = document.querySelector("[data-hfb-068-saving-value]");
    var text = src ? src.textContent.replace(/\s+/g, " ").trim() : "";
    if (!text) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var next = "You save " + text;
    if (el.textContent !== next) el.textContent = next;
  }

  var pause = false;

  function sync() {
    if (pause) return;
    pause = true;
    placeSheet();
    document.querySelectorAll(".rc90-item").forEach(syncItem);
    syncSave();
    window.setTimeout(function () { pause = false; }, 0);
  }

  function placeSheet() {
    var sheets = document.querySelectorAll(".hfb-073-sheet");
    if (!sheets.length) return;
    var keep = null;
    Array.prototype.forEach.call(sheets, function (sheet) {
      if (sheet.parentNode === document.body) keep = sheet;
    });
    if (!keep) keep = sheets[0];
    if (keep.parentNode !== document.body) document.body.appendChild(keep);
    Array.prototype.forEach.call(sheets, function (sheet) {
      if (sheet !== keep) sheet.remove();
    });
  }

  function closeSheet() {
    var sheet = document.querySelector(".hfb-073-sheet");
    if (sheet) sheet.hidden = true;
    activeItem = null;
    picked = "";
  }

  function openSheet(item) {
    var select = item.querySelector(".upsell__options");
    var list = document.querySelector("[data-hfb-073-list]");
    var sheet = document.querySelector(".hfb-073-sheet");
    if (!select || !list || !sheet) return;
    activeItem = item;
    picked = select.value;
    list.innerHTML = "";
    Array.prototype.forEach.call(select.options, function (option) {
      var row = document.createElement("button");
      row.type = "button";
      row.className = "hfb-073-sheet__row" + (option.value === picked ? " is-current" : "");
      row.setAttribute("data-plan", option.value);
      row.innerHTML =
        '<span class="hfb-073-sheet__radio" aria-hidden="true"></span>' +
        '<span class="hfb-073-sheet__name">' +
        pretty(option.textContent) +
        "</span>" +
        (option.value === select.value ? '<span class="hfb-073-sheet__badge">CURRENT</span>' : "");
      list.appendChild(row);
    });
    sheet.hidden = false;
  }

  function saveSheet() {
    if (!activeItem || !picked) {
      closeSheet();
      return;
    }
    var select = activeItem.querySelector(".upsell__options");
    if (select && select.value !== picked) {
      select.value = picked;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
    closeSheet();
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".hfb-073-sheet")) event.stopPropagation();
    var change = event.target.closest(".hfb-073-freq");
    if (change) {
      event.preventDefault();
      event.stopPropagation();
      var item = change.closest(".rc90-item");
      if (item) openSheet(item);
      return;
    }
    var row = event.target.closest("[data-plan]");
    if (row && row.closest(".hfb-073-sheet")) {
      picked = row.getAttribute("data-plan");
      row.parentNode.querySelectorAll(".hfb-073-sheet__row").forEach(function (other) {
        other.classList.toggle("is-current", other === row);
      });
      return;
    }
    if (event.target.closest("[data-hfb-073-save]")) {
      event.preventDefault();
      saveSheet();
      return;
    }
    if (event.target.closest("[data-hfb-073-close]")) {
      event.preventDefault();
      closeSheet();
    }
  }, true);

  document.addEventListener("change", function (event) {
    if (event.target.matches && event.target.matches("[data-hfb-068-toggle]")) {
      var offer = event.target.closest(".hfb-068-offer");
      if (offer) offer.classList.toggle("is-checked", event.target.checked);
    }
    if (event.target.classList && (event.target.classList.contains("upsell__checkbox") || event.target.classList.contains("upsell__options"))) {
      window.setTimeout(sync, 40);
    }
  });

  document.addEventListener("cart:updated", function () {
    window.setTimeout(sync, 60);
  });

  function boot() {
    sync();
    var root = document.querySelector(".rc90");
    if (!root || root.getAttribute("data-hfb-073") === "1") return;
    root.setAttribute("data-hfb-073", "1");
    var obs = new MutationObserver(function () {
      sync();
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
